module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 pb-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "d-flex mb-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.customer.name),
      expression: "reservation.customer.name"
    }],
    staticClass: "full",
    class: {
      'border-color-6': _vm.$v.reservation.customer.name.$invalid && !_vm.$v.reservation.customer.name.required
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.customer.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.customer, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_vm._m(1), _vm._v(" "), _c('country-picker', {
    attrs: {
      "topCodes": _vm.topCountries,
      "selectedCountryValue": _vm.selectedCountry,
      "disabled": false,
      "allowEmpty": false,
      "customClass": 'mb-2',
      "error": !_vm.selectedCountry
    },
    on: {
      "input": function($event) {
        return _vm.updateCountry($event, 'country')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Phone Number")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 pr-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.customer.dial),
      expression: "reservation.customer.dial"
    }],
    staticClass: "fs-bigger bg-lighter w-100",
    attrs: {
      "type": "text",
      "placeholder": "+351"
    },
    domProps: {
      "value": (_vm.reservation.customer.dial)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.customer, "dial", $event.target.value)
      }, _vm.onDialInput]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-8 pl-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.customer.phone),
      expression: "reservation.customer.phone"
    }],
    staticClass: "fs-bigger bg-lighter w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.customer.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.customer, "phone", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("\n                    Email\n                    "), (_vm.$v.reservation.customer.email.$invalid) ? _c('span', {
    staticClass: "color-6"
  }, [(!_vm.$v.reservation.customer.email.email) ? _c('span', [_vm._v("Invalid")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.customer.email),
      expression: "reservation.customer.email"
    }],
    staticClass: "full mb-2",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.reservation.customer.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.customer, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('label', [_vm._v("Hotel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.customer.accomodation),
      expression: "reservation.customer.accomodation"
    }],
    staticClass: "full",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.customer.accomodation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.customer, "accomodation", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Room")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.customer.room),
      expression: "reservation.customer.room"
    }],
    staticClass: "full",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.customer.room)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.customer, "room", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 d-flex align-items-center mt-3"
  }, [_c('checkbox', {
    staticClass: "mr-2",
    model: {
      value: (_vm.reservation.customer.sendEmailCopy),
      callback: function($$v) {
        _vm.$set(_vm.reservation.customer, "sendEmailCopy", $$v)
      },
      expression: "reservation.customer.sendEmailCopy"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Send a confirmation email to the customer")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pb-3 flex-column"
  }, [_c('div', {
    staticClass: "row h-100"
  }, [(_vm.canSeeInternalNote) ? _c('div', {
    staticClass: "col-sm-12 d-flex flex-column mb-3"
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.internalNote),
      expression: "reservation.internalNote"
    }],
    staticClass: "flex-grow-1 p-1 fs-bigger bg-lighter darker bold",
    attrs: {
      "disabled": !_vm.canEditInternalNote,
      "rows": "1"
    },
    domProps: {
      "value": (_vm.reservation.internalNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "internalNote", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 d-flex flex-column"
  }, [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.note),
      expression: "reservation.note"
    }],
    staticClass: "flex-grow-1 p-1 fs-bigger bg-lighter darker bold",
    attrs: {
      "rows": "1"
    },
    domProps: {
      "value": (_vm.reservation.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "note", $event.target.value)
      }
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                    Name "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                    Country "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                    Internal notes:"), _c('span', {
    staticClass: "fs-smaller normal ml-1"
  }, [_vm._v("(internal use only)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Notes:"), _c('span', {
    staticClass: "fs-smaller normal ml-1"
  }, [_vm._v("(agents can see these)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b55782b4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Details/CustomerDetails.vue
// module id = 2477
// module chunks = 0